import React from "react";
import { Redirect, Route } from "react-router-dom";

function UnprotectedRoute({ comp: Component, ...restOfProps }) {
  const isAuthenticated = localStorage.getItem("token");
  console.log("Checking...: ", isAuthenticated )
  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated == null ? <Component {...props} /> : <Redirect to="/landing" />
      }
    />
  );
}

export default UnprotectedRoute;